<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <KTCodePreview v-bind:title="'Rekapitulasi Evaluasi Dosen Oleh '+titlePage">
          <template v-slot:toolbar>
          </template>
          <template v-slot:body>
            <v-card>
              <v-card-title>
                <v-spacer></v-spacer>
                <v-text-field v-model="search" label="Search" single-line hide-details></v-text-field>
              </v-card-title>
              <v-data-table :headers="headers" :items="dataHasil" :search="search">
                <template v-slot:item.no="{ item, index }">
                  {{ index + 1 }}
                </template>
                <template v-slot:item.nilaiAkhir="{ item }">
                  <b-avatar :class="item.nilaiAkhir ? item.nilaiAkhir : 'E'" :text="item.nilaiAkhir ? item.nilaiAkhir : 'E'" size="3rem" />
                </template>
                <template v-slot:item.pertemuan="{ item }">
                    <span>{{ item.pertemuan }}x</span>
                </template>
                <template v-slot:item.action="{ item }">
                  <router-link to="/edops/staff/detail-hasil-edops">
                    <ButtonComponent colors="#3751E4" name="detail" Title="detail" rounded="xl" dataTitleTooltip="Lihat Data" />
                    <!-- <ButtonComponent colors="#FFC107" name="eye" dataTitleTooltip="Lihat Data" /> -->
                  </router-link>
                </template>
              </v-data-table>
            </v-card>
          </template>
        </KTCodePreview>

      </div>
    </div>
  </div>
</template>

<script>
import KTCodePreview from "@/view/content/CardContent.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import ButtonComponent from "@/view/content/components/button/buttonComponent.vue"
import axios from "axios";
// import cardKriteriaPenilaian from "@/view/content/components/card/KriteriaPenilaian.vue";
// import EdopsStaffNav from "@/view/content/components/nav/EdopsStaffNav.vue"

export default {
  data() {
    return {
      dataLogin: JSON.parse(localStorage.getItem('dataLogin')),
      dataHasil: [],
      search: "",
      headers: [
        { text: "No", value: "no", sortable: false },
        { text: "Nama Dosen", value: "namaDosen" },
        { text: "Mata Kuliah", value: "matkul" },
        { text: "Total Nilai", value: "total", align: 'center' },
        { text: "Nilai Akhir", value: "nilaiAkhir" },
        { text: "Aksi", value: "action", sortable: false }
      ],
      titlePage: '',
    };
  },
  components: {
    KTCodePreview,
    ButtonComponent,
    // cardKriteriaPenilaian,
    // EdopsStaffNav,
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "EDOPS" },
      { title: "Master EDOPS Staff" },
    ]);

    this.titlePage = this.$route.name;
    this.getData()
  },
  methods: {

    async getData() {
      try {
        let result = await axios.get(`recap-staff/rating-result`);
        result.data.data.map((dosen, index) => {
          let obj =
          {
            no: index + 1,
            namaDosen: dosen.nama_dosen,
            matkul: dosen.matakuliah,
            total: dosen.nilai_total,
            nilaiAkhir: dosen.predikat,
          };
          this.dataHasil.push(obj);
        })
      } catch (err) {
        this.$swal(`Eror Store Data`);
      }
    },
  },
  computed: {
    config() {
      let dataConfig = {
        headers: { Authorization: `Bearer ${this.dataLogin.access_token}`, 'Content-Type': 'application/json' }
      }
      return dataConfig
    }
  }
}
</script>

<style>
.A {
  background-color: #3751E4;
  color: white
}

.B {
  background-color: #17A1FA;
  color: white
}

.C {
  background-color: #FFB800;
  color: white
}

.D {
  background-color: #EB8002;
  color: white
}

.E {
  background-color: #EF4848;
  color: white
}
</style>